import { HeroesRepository } from "../../api/repositories/stats/heroes";
import { setGlobalState } from "../hooks/global-state";
import { AuthService } from "./auth";
import { initLocalization } from "./localization";

export class InitService {
    private _heroesRepository = new HeroesRepository();
    private _authRespository = new AuthService();

    async initAllAndValidate(): Promise<boolean> {
        try {
            await Promise.all([
                this.initHeroes(),
                this._authRespository.initAuth(),
                initLocalization()
            ]);

            return true;
        } catch (error) {
            return false;
        }
    }


    async initHeroes() {
        const response = await this._heroesRepository.getAll();

        if (response.hasErrors) {
            console.log('heroes upload error: ' + response.errors[0]);
            return;
        }

        setGlobalState('heroes', response.data?.heroes!);
        setGlobalState('lastAddedHero', response.data?.lastAddedHero!);
    }
}
